import { Tag as AntdTag, Tooltip } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  getCustomerSatisfactionSummaryColor,
  getCustomerSatisfactionSummaryLabel,
} from "../../../models/customer-satisfaction/enum";
import {
  ICustomerSatisfactionStatusSummary,
} from "../../../models/order/response";

interface IProps {
  status?: ICustomerSatisfactionStatusSummary | null;
  fallbackStatus?: number | null;
}

const CustomerSatisfactionStatusTag: React.FC<IProps> = ({
  status,
  fallbackStatus,
}) => {
  const { t } = useTranslation();
  const label = getCustomerSatisfactionSummaryLabel(status, fallbackStatus);
  const title = status?.label || t(label);
  const tag = (
    <AntdTag color={getCustomerSatisfactionSummaryColor(status, fallbackStatus)}>
      {title}
    </AntdTag>
  );

  if (!status?.determinedAt) return tag;

  return (
    <Tooltip
      title={`${t("determined_at")}: ${moment(status.determinedAt).format(
        "YYYY-MM-DD HH:mm:ss",
      )}`}
    >
      {tag}
    </Tooltip>
  );
};

export default CustomerSatisfactionStatusTag;
